import {useFeatureFlags} from "../../providers/FeatureFlagProvider/FeatureFlagProvider";
import {useGetIsArielEmployee} from "../Organization/useGetIsArielEmployee";

export const useIsFleetDataQualityEnabled = (): boolean =>{
    const featureFlags = useFeatureFlags();
        return featureFlags.includes("isFleetDataQualityEnabled")
}